/* Ritual landing page behaviour. Add-to-cart itself is Dawn's product-form.js;
   this file only handles the offer selector display, box quantities, the warmth
   dial, the gallery thumbnails and the mobile sticky buy bar. */
(() => {
  'use strict';
  if (window.__ritualInit) return;
  window.__ritualInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function init() {
    const hero = $('[data-r-hero]');

    /* ---------- offers -> price, sticky bar, box ---------- */
    const radios = hero ? $$('input[type=radio][name=id]', hero) : [];
    const selected = () => radios.find((r) => r.checked) || radios[0];
    /* With one offer the section renders no chooser, so the set name is not something the
       visitor picked: the markup names the product instead and this file leaves it alone.
       Re-add Offer blocks for the bundles and the labels start tracking the choice again. */
    const multiOffer = radios.length > 1;

    function renderOffer() {
      const r = selected();
      if (!r) return;
      const price = r.dataset.price;
      const label = r.dataset.label;
      const devices = parseInt(r.dataset.devices, 10) || 1;
      const quartz = r.dataset.quartz === 'true';
      $$('[data-r-price]').forEach((el) => (el.textContent = price));
      $$('[data-r-sticky-price]').forEach((el) => (el.textContent = price));
      if (multiOffer) $$('[data-r-sticky-name]').forEach((el) => (el.textContent = label));
      $$('[data-r-box]').forEach((box) => {
        if (multiOffer) $$('[data-r-box-label]', box).forEach((el) => (el.textContent = label));
        $$('[data-per-device] [data-qty]', box).forEach((el) => (el.textContent = devices + ' ×'));
        $$('[data-quartz-only]', box).forEach((el) => (el.hidden = !quartz));
      });
      const url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== r.value) {
        url.searchParams.set('variant', r.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
    radios.forEach((r) => r.addEventListener('change', renderOffer));
    renderOffer();

    /* ---------- gallery ---------- */
    $$('[data-r-gallery]').forEach((g) => {
      const thumbs = $$('[data-thumb]', g);
      const stage = $('.r-gallery__stage', g);
      thumbs.forEach((t) =>
        t.addEventListener('click', () => {
          const i = t.dataset.thumb;
          thumbs.forEach((x) => {
            const on = x === t;
            x.classList.toggle('r-is-active', on);
            x.setAttribute('aria-pressed', String(on));
          });
          let blend = false;
          $$('[data-slide]', g).forEach((s) => {
            s.hidden = s.dataset.slide !== i;
            if (!s.hidden) blend = s.dataset.blend === 'true';
          });
          stage.classList.toggle('r-is-photo-active', !blend);
        })
      );
    });

    /* ---------- warmth dial ---------- */
    $$('[data-r-dial]').forEach((dial) => {
      const section = dial.closest('.r-warmth');
      const levels = $$('[role=radio]', dial);
      const thermo = $('[data-r-thermo]', section);
      const setLevel = (idx, focus) => {
        levels.forEach((b, i) => {
          const on = i === idx;
          b.setAttribute('aria-checked', String(on));
          b.tabIndex = on ? 0 : -1;
        });
        const b = levels[idx];
        thermo.dataset.level = b.dataset.level;
        $('[data-r-thermo-f]', section).textContent = b.dataset.f;
        $('[data-r-thermo-c]', section).textContent = b.dataset.c;
        $('[data-r-dial-note]', section).textContent = b.dataset.note;
        if (focus) b.focus();
      };
      levels.forEach((b, i) => {
        b.addEventListener('click', () => setLevel(i));
        b.addEventListener('keydown', (e) => {
          const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
          if (!d) return;
          e.preventDefault();
          setLevel((i + d + levels.length) % levels.length, true);
        });
      });
    });

    /* ---------- in-page links to the buy box focus the selected offer ---------- */
    $$('a[href="#buy"]').forEach((a) =>
      a.addEventListener('click', (e) => {
        if (!hero) return;
        e.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        $('.r-buybox', hero).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        /* Several offers: focus the selection so it can be changed. One (hidden) offer:
           there is nothing to choose, so focus the primary Buy it now button instead. */
        const target = multiOffer ? selected() : $('[data-r-buy-now]', hero);
        if (target) setTimeout(() => target.focus({ preventScroll: true }), reduce ? 0 : 400);
      })
    );

    /* ---------- Buy it now -> straight to checkout (2026-09-23) ----------
       One-product store: a cart page is a step that can only lose people. This adds
       the line through Shopify's AJAX cart and then sends the browser to /checkout.
       With JavaScript off the click is never intercepted and the form POSTs to
       /cart/add as normal, so the button still works. Any failure falls back to the
       same plain submit rather than leaving a dead button. */
    function buyNow(btn) {
      const form = btn.form;
      if (!form) return false;
      const data = new FormData(form);
      data.delete('add');
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      })
        .then((r) => {
          if (!r.ok) throw new Error('add failed: ' + r.status);
          window.location.assign(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'checkout'
            : '/checkout');
          return true;
        })
        .catch(() => {
          /* Let the browser do the ordinary thing rather than swallow the click. */
          btn.classList.remove('loading');
          btn.removeAttribute('aria-busy');
          if (form.requestSubmit) form.requestSubmit(btn);
          else form.submit();
          return false;
        });
    }
    $$('[data-r-buy-now]').forEach((btn) =>
      btn.addEventListener('click', (e) => {
        if (btn.disabled) return;
        e.preventDefault();
        buyNow(btn);
      })
    );

    /* ---------- sticky buy bar (mobile) ---------- */
    const sticky = $('[data-r-sticky]');
    const mainBtn = $('[data-r-buy-now]');
    if (sticky && mainBtn) {
      const stickyBtn = $('[data-r-sticky-add]', sticky);
      const sync = () => {
        const show = mainBtn.getBoundingClientRect().bottom < 0;
        if (show === sticky.classList.contains('r-is-visible')) return;
        sticky.classList.toggle('r-is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn.tabIndex = show ? 0 : -1;
      };
      addEventListener('scroll', sync, { passive: true });
      addEventListener('resize', sync, { passive: true });
      sync();
      stickyBtn.addEventListener('click', () => {
        /* Mirror the primary button exactly, including going to checkout. */
        if (!mainBtn.disabled) buyNow(mainBtn);
      });
    }
  }

  /* ---------- scroll reveal (2026-09-23) ----------
     Sections fade and rise as they arrive; grids stagger their children. Classes
     are added here rather than in the Liquid so the sections stay semantic and
     the whole effect lifts out by deleting this function plus the matching CSS.
     Nothing is ever hidden unless we are certain we can reveal it again:
       - reduced-motion and a missing IntersectionObserver skip it entirely;
       - the Theme Editor is excluded, because Shopify re-renders a section on
         every setting change and a merchant would watch the page blink;
       - a 1.5s failsafe reveals everything if a callback never lands.
     Re-runs on shopify:section:load so a re-rendered section still animates. */
  function reveal(root) {
    if (window.Shopify && window.Shopify.designMode) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    const scope = root || document;
    const groups = Array.from(scope.querySelectorAll('.r-steps, .r-promise__grid, .r-contents'));
    const singles = Array.from(scope.querySelectorAll('.r-warmth__copy, .r-thermo, .r-how h2, .r-box__grid, .r-faq__intro, .r-faq__list'));
    groups.forEach((el) => el.classList.add('r-reveal-group'));
    singles.forEach((el) => el.classList.add('r-reveal'));
    const watched = groups.concat(singles);
    if (!watched.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('r-is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    watched.forEach((el) => io.observe(el));
    setTimeout(() => watched.forEach((el) => el.classList.add('r-is-in')), 1500);
  }

  function boot() { init(); reveal(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (e) => reveal(e.target));
})();
